import styled from 'styled-components';

const transitionTime = 400;

const StyledSlide = styled.div`
  position: ${(props) => props.active ? 'relative' : 'absolute'};
  width: 100%;
  transform: translateX(-100%);
  opacity: 0;
  transition: transform ${transitionTime}ms ease;
  will-change: transform, opacity;
  padding-left: 0.5em;
  ${(props) => props.next ? 'transform: translateX(200%);' : ''}
  ${(props) => props.active ? 'transform: translateX(0%); opacity: 1;' : ''}
`;

const CarouselContent = styled.div`
  width:100%;
  overflow: hidden;
  position: relative;
`;

const CarouselContainer = styled.div`
  position: relative;
  display: inline-flex;
  width: 100%;
`;

const SlideItem = styled.div`
  width: ${(props) => props.itemWidth}%;
  position: relative;
  display: inline-block;
`;

export { StyledSlide, CarouselContent, CarouselContainer, SlideItem };
